<div class="container-fluid mt-3">
    <h1>{{ 'titles_userProfile' | translate: 'online' : 'common' }}</h1>
    @if (user$ | async; as user) {
        <form
            [formGroup]="userForm"
            (ngSubmit)="onSubmit()"
            style="max-width: 50rem; margin: 0 auto">
            <app-input-text-group
                [formControl]="userForm.controls.fullName"
                [label]="'common_NAME' | translate: 'online' : 'common'"
                [maxLength]="50" />

            <app-input-text-group
                [formControl]="userForm.controls.username"
                [label]="'properties_username' | translate: 'online' : 'common'" />
            @if (user.debtorNo != null) {
                <p class="text-secondary">
                    {{ 'user_debtorno_info' | translate }} {{ user.debtorNo }}
                </p>
            }

            <app-input-text-group
                [formControl]="userForm.controls.email"
                [label]="'properties_email' | translate: 'online' : 'common'"
                [maxLength]="emailMaxLength" />

            <app-input-select-option-group
                [formControl]="userForm.controls.language"
                [label]="'properties_language' | translate: 'online' : 'common'"
                [data]="languageOptions" />

            <div class="d-flex justify-content-end gap-3">
                <a [href]="resetPasswordUrl" class="btn btn-text-primary">
                    {{ 'actions_resetPassword' | translate: 'online' : 'common' }}
                </a>
                <button class="btn btn-primary" [disabled]="isSaving()" type="submit">
                    {{ 'actions_saveChanges' | translate: 'online' : 'common' }}
                </button>
            </div>
        </form>
    }
</div>
